import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'

const styles = {
  paper: {
    boxShadow: '0 5px 20px 1px rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
  }
}

export default withStyles(styles)(Dialog)
